const convertToShortLocale = (lang) => {
  if (lang === 'zh-tw') return 'tw';
  if (lang === 'zh-cn') return 'cn';
  return lang || '';
};

const convertToDataLanguage = (lang) => {
  if (lang === 'tw') return 'zh-tw';
  if (lang === 'cn') return 'zh-cn';
  if (lang === 'ja') return 'jp';
  return lang || '';
};

export default {
  convertToDataLanguage,
  convertToShortLocale,
};
